import { render, staticRenderFns } from "./AddToMyBucketListButton.vue?vue&type=template&id=53e0ec87&"
import script from "./AddToMyBucketListButton.vue?vue&type=script&lang=js&"
export * from "./AddToMyBucketListButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports